import React, { useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';


import {
    Grid,
    Table,
    TableContainer,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    Typography,
    Alert,
    Backdrop,
    CircularProgress,
    Tooltip,
    IconButton
} from '@mui/material';
import { makeStyles } from '@material-ui/styles';
import ThemeCustomization from 'src/themesNew';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import Pagination from '@mui/material/Pagination';
import SubCard from 'src/components/cards/SubCard';
import PrintIcon from '@mui/icons-material/Print';
import axios from 'src/utils/axios';
import ExcelFileCreator from 'src/components/ExcelFileCreator';



function EducationalExpertise({ EmployeeNr }) {
    const theme = useTheme();
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const useStyles = makeStyles(() => ({
        ul: {
            '& .MuiPaginationItem-root': {
                '&.Mui-selected': {
                    background: '#FF9800',
                    color: 'white',
                    borderRadius: '50%',
                },
            },
        },
        backdrop: {
            zIndex: theme.zIndex.drawer + 1,
            color: '#fff',
        },
        responsiveContainer: {
            marginTop: theme.spacing(3),
            [theme.breakpoints.between('md', 'lg')]: {
                maxHeight: '70vh',
                overflowX: 'hidden',
                overflowY: 'scroll'
            },
            [theme.breakpoints.down('sm')]: {
                maxHeight: '60vh',
                overflow: 'scroll'
            }
        },
    }));
    const classes = useStyles();
    const [educationalExpertiseData, setEducationalExpertiseData] = useState([]);

    useEffect(() => {
        getEducationalExpertiseData();
    }, []);


    const getEducationalExpertiseData = () => {
        setLoading(true);
        axios.get(`GetEmployeeEducationalExpertise/${EmployeeNr}`)
            .then((res) => {
                const data = res.data;
                if (data.length === 0) {
                    setLoading(false);
                    setEducationalExpertiseData([]);
                    return;
                }
                setEducationalExpertiseData(res.data);
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
            });
    };


    const handlePageChange = (event, value) => {
        setPage(value);
    };

    const handleExportClick = () => {
        setLoading(true);
        var exportData = [];
        educationalExpertiseData.map((row) => {
            exportData.push({
                "Uzmanlık Adı": row.ExpertiseName,
                "Atanma Tarihi": row.ExpertiseAssignmentDate,
                "Uzmanlığı Aldığı Eğitimin Adı": row.CourseName,
                "Eğitimin Başlama Tarihi": row.StartDate,
                "Eğitimin Bitiş Tarihi": row.EndDate,
                "Uzmanlık Durumu": row.ExpertiseStatus ? 'Aktif' : 'Pasif'
            });
        });
        ExcelFileCreator(exportData, `${EmployeeNr} - Eğitim Uzmanlıkları`);
        setLoading(false);
    };


    return (
        <ThemeCustomization>
            {
                loading ?
                    <Backdrop className={classes.backdrop} open={loading}>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    : ''
            }
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <SubCard title={
                            <Grid container justify="center" alignItems="center" >
                                <Grid item xs={4} sm={4} md={4} >
                                    Eğitim Uzmanlıkları
                                </Grid>
                                <Grid item xs={4} sm={4} md={4} >
                                    <Grid container justifyContent="center" alignItems="center">
                                        <Grid item >
                                            {educationalExpertiseData.length !== 0 && <Pagination
                                                count={Math.ceil(educationalExpertiseData.length / 10)}
                                                page={page}
                                                onChange={handlePageChange}
                                                variant="outlined"
                                                classes={{
                                                    root: classes.ul,
                                                }}
                                            />}
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={4} sm={4} md={4} >
                                    <Grid container justifyContent="right" alignItems="center">
                                        <Grid item >
                                            <Tooltip title="Yazdır">
                                                <IconButton size="large" onClick={handleExportClick}>
                                                    <PrintIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        }
                            style={{ minHeight: 400, maxHeight: 400, overflowY: 'auto' }}>
                            {educationalExpertiseData.length === 0 ? (
                                <Alert variant="outlined" severity="warning" sx={{ borderColor: theme.palette.warning.dark }}>
                                    Bu çalışanın eğitim uzmanlığı bulunmamaktadır.
                                </Alert>) :
                                <TableContainer >
                                    <Table stickyHeader aria-label="sticky table" size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Uzmanlık Adı</TableCell>
                                                <TableCell>Atanma Tarihi</TableCell>
                                                <TableCell>Uzmanlığı Aldığı Eğitimin Adı</TableCell>
                                                <TableCell>Eğitimin Başlama Tarihi</TableCell>
                                                <TableCell>Eğitimin Bitiş Tarihi</TableCell>
                                                <TableCell>Uzmanlık Durumu</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                                educationalExpertiseData.map((row) => (
                                                    <TableRow hover key={row.EducationalExpertiseNr}>
                                                        <TableCell>{row.ExpertiseName}</TableCell>
                                                        <TableCell>{row.ExpertiseAssignmentDate}</TableCell>
                                                        <TableCell>{row.CourseName}</TableCell>
                                                        <TableCell>{row.StartDate}</TableCell>
                                                        <TableCell>{row.EndDate}</TableCell>
                                                        <TableCell>{row.ExpertiseStatus ? 'Aktif' : 'Pasif'}</TableCell>
                                                    </TableRow>
                                                ))
                                            }

                                        </TableBody>
                                    </Table>
                                </TableContainer>}
                        </SubCard>
                    </Grid>
                </Grid>
            </LocalizationProvider>
        </ThemeCustomization >

    );
}

export default EducationalExpertise;
